import { useParams } from "react-router-dom";
import { ViewLayout } from "../../films/sections/view.layout";
import { ProjectKind } from "../../../enums/ProjectKind";
import { styled } from "styled-components";
import { Card, Tabs } from "antd";
import { Spacer } from "../../../components/ui/spacer/spacer.component";
import { Row } from "../../../components/ui/grid/row.component";
import { Pill } from "../../../components/ui/pill/pill.component";
import { colors } from "../../../theme/colors";
import _ from "lodash";
import { CastView } from "../components/cast-view.component";
import { useEffect, useState } from "react";

export const ViewCastCrew = () => {
  const [activeKey, setActiveKey] = useState("1");
  const { id } = useParams();

  useEffect(() => {
    const url = window.location.hash.replace("#", "");
    let activeKey = "1";

    switch (url) {
      case "directors":
        activeKey = "1";
        break;
      case "producers":
        activeKey = "2";
        break;
      case "cast":
        activeKey = "3";
        break;
      case "crew":
        activeKey = "4";
        break;
      default:
        break;
    }

    setActiveKey(activeKey);
  }, []);

  return (
    <ViewLayout
      id={id ?? ""}
      kind={ProjectKind.Series}
      showEpisodes={false}
      title="Cast and Crew"
      subtitle="Friends Reunion"
    >
      <Tabs
        style={{ width: "100%" }}
        activeKey={activeKey}
        onChange={(activeKey) => setActiveKey(activeKey)}
        items={[
          {
            key: "1",
            label: "Directors",
            children: (
              <Row
                style={{ gap: "2rem", overflowX: "scroll", maxWidth: "100%" }}
              >
                <CastView name="Aarush Yadav" description="2 episodes" />
                <CastView name="Aarush Yadav" description="2 episodes" />
              </Row>
            ),
          },
          {
            key: "2",
            label: "Producers",
            children: (
              <Row
                style={{ gap: "2rem", overflowX: "scroll", maxWidth: "100%" }}
              >
                <CastView name="Aarush Yadav" description="2 episodes" />
                <CastView name="Aarush Yadav" description="2 episodes" />
              </Row>
            ),
          },
          {
            key: "3",
            label: "Cast",
            children: (
              <Row
                style={{ gap: "2rem", overflowX: "scroll", maxWidth: "100%" }}
              >
                <CastView name="Aarush Yadav" description="2 episodes" />
                <CastView name="Aarush Yadav" description="2 episodes" />
              </Row>
            ),
          },
          {
            key: "4",
            label: "Crew",
            children: (
              <Row
                style={{ gap: "2rem", overflowX: "scroll", maxWidth: "100%" }}
              >
                <CastView name="Aarush Yadav" description="2 episodes" />
                <CastView name="Aarush Yadav" description="2 episodes" />
              </Row>
            ),
          },
        ]}
      />
    </ViewLayout>
  );
};

const Synopsis = styled.p`
  font-size: 1.5rem;
  color: ${colors.white.hex};
  font-weight: 400;
`;
